import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {Translate, I18n} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

import config from '../../../../../../config';
import {pathResolver} from '../../../../../utils/basePathHelper';

function AccessPandaModal(props) {
  return (
    <Modal
      defaultStyles={{
        overlay: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1
        },
        content: {
          backgroundColor: '#fff',
          borderRadius: 4,
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
          minWidth: 300,
          maxWidth: 700,
          outline: 0,
          padding: 20,
          position: 'relative'
        }
      }}
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div>
        <div className='my-4 d-flex flex-column align-items-center'>
          <img
            alt="icon panda"
            src={pathResolver('resources/img/logo_panda.png')}
            style={{width: '250px'}}
          />
          <div className='my-4 d-flex flex-column align-items-start'>
            <Translate
              className='my-2'
              value='panda.access.text1'
            />
            <Translate
              className='my-2'
              value='panda.access.text2'
            />
            <Translate
              className='my-2'
              value='panda.access.text3'
            />
            <a
              className='my-2'
              target="_blank"
              href={config.discoverPanDaUrl}
              rel="noopener noreferrer"
              title={I18n.t('panda.access.text4')}
            >
              <Translate value='panda.access.text4'/>
            </a>
            <Translate
              className='my-2'
              value='panda.access.text5'
            />
          </div>
        </div>
        <div className="actions col-12 inline-container space-between">
          <button
            type="button"
            className="large secondary inline-container"
            onClick={props.onClose}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
          <div onClick={props.onConfirm}>
            <a
              target="_blank"
              href={props.urlToPanda}
              className="button-square px-1 flex-container"
              rel="noopener noreferrer"
              title={I18n.t('panda.access.confirm')}
            >
              <Translate value="panda.access.confirm"/>
            </a>
          </div>
        </div>

      </div>
    </Modal>
  );
}

AccessPandaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  urlToPanda: PropTypes.string.isRequired
};

export default AccessPandaModal;
